<template>
  <div
    v-if="blok.hls_playlist_url"
    class="m-case-video-bunny"
    :data-comp="blok.component"
    :class="[`--align-h-${blok.align_horizontal}`]"
  >
    <div class="m-case-video-bunny__video">
      <h-video-hls-player :hls-playlist-url="blok.hls_playlist_url" :poster-image="blok.poster_image" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
});
</script>

<style lang="scss" scoped>
.m-case-video-bunny {
  --offset-y-base: 20vw;
  --width: v-bind(props.blok.width);
  --span: v-bind(props.blok.span);
  --offset-y: v-bind(props.blok.offset_y);

  flex: 0 1 calc(var(--span) / 12 * 100%);
  transform: translateY(calc(var(--offset-y) * var(--offset-y-base)));
  display: flex;
  justify-content: center;
  align-items: center;
  // outline: 1px solid blueviolet;

  @include global.breakpoint(tablet-portrait, max) {
    // slightly increase width on mobile
    --width: calc(min(v-bind(props.blok.width) + 0.15, 1));
  }

  &.--align-h {
    &-left {
      justify-content: flex-start;
    }
    &-right {
      justify-content: flex-end;
    }
  }

  &__video,
  > picture,
  > img {
    width: calc(var(--width) * 100%);
  }
}
</style>
